import { render, staticRenderFns } from "./DashBoardPlugin.vue?vue&type=template&id=07b40ade&scoped=true"
import script from "./DashBoardPlugin.vue?vue&type=script&lang=ts"
export * from "./DashBoardPlugin.vue?vue&type=script&lang=ts"
import style0 from "./DashBoardPlugin.vue?vue&type=style&index=0&id=07b40ade&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b40ade",
  null
  
)

export default component.exports